/**
 * Build correct Cloudinary URL from any image path format.
 * Handles: string URLs, public_ids, and accidentally-passed objects.
 */
export function buildImageUrl(imagePath) {
  if (!imagePath) return '';

  // ── Guard: if an object was passed instead of a string ──────────────────────
  // This happens when a full Cloudinary upload-result object is stored instead
  // of just the URL string. Extract the URL from known Cloudinary response keys.
  if (typeof imagePath === 'object') {
    imagePath =
      imagePath.secure_url ||
      imagePath.url ||
      imagePath.image_url ||
      imagePath.path ||
      '';
    if (!imagePath) return '';
  }

  const cloudName = 'dgs6jzxay';
  let cleanPath = String(imagePath).trim();

  // Safety: if it still looks like an object string, bail out
  if (!cleanPath || cleanPath === '[object Object]') return '';

  // Already a full Cloudinary URL — force https and return
  if (cleanPath.includes('res.cloudinary.com')) {
    return cleanPath.replace('http://', 'https://');
  }

  // Server URL containing /uploads/ — extract public_id
  if (cleanPath.includes('/uploads/')) {
    const parts = cleanPath.split('/uploads/');
    cleanPath = parts[parts.length - 1];
  }

  // Public ID format (workshop/task-images/abc123) — build full URL
  return `https://res.cloudinary.com/${cloudName}/image/upload/${cleanPath}`;
}
